<template>
    <div class="layout layout-center menu-bg">
        <div v-show="view == 'mainmenu'" id="mainmenu">
            <h1>Madvolley</h1>
            <ul class="actions">
                <li><a @click="quickstart" href="javascript:">Quickstart</a></li>
                <li><a @click="newgame" href="javascript:">New Game</a></li>
                <li><a @click="showOptions" href="javascript:">Options</a></li>
            </ul>
        </div>

        <div v-show="view == 'p'">
            <h1>Player</h1>
            <ul class="carousel">
                <li v-for="player in $store.state.res.players" :key="player">
                    <a @click="select('p', player)"><Picture :src="'res/gfx/' + player + '_preview.png'"></Picture></a>
                </li>
            </ul>
        </div>

        <div v-show="view == 'l'">
            <h1>Level</h1>
            <ul class="carousel">
                <li v-for="level in $store.state.res.levels" :key="level">
                    <a @click="select('l', level)"><Picture :src="'res/gfx/preview_' + level + '.png'"></Picture></a>
                </li>
            </ul>
        </div>

        <div v-show="view == 't'">
            <h1>Game Type</h1>
            <ul class="carousel wide">
                <li v-for="gameType in $store.state.res.gameTypes" :key="gameType">
                    <a @click="select('t', gameType)" href="javascript:"><Picture :src="'res/gfx/gametype' + gameType + '_preview.png'"></Picture></a>
                </li>
            </ul>
        </div>

        <div v-show="view == 'options'" class="popup">
            <h1>Options</h1>
            <p>
                <label>Difficulty:</label>
                <select v-model="difficulty">
                    <option v-for="(d, index) in $store.state.res.difficulties" :key="d" :value="index + 1">{{ d }}</option>
                </select>
            </p>
            <p>
                <label>Sound:</label>
                <input type="checkbox" v-model="sound" />
            </p>
            <div class="small text-muted mt-4">Version {{ version }}</div>
        </div>

        <div v-show="backable" id="buttonbar">
            <a @click="back" href="javascript:" class="button"><Picture src="res/gfx/back.png"></Picture></a>
        </div>
    </div>
</template>

<script>
import { ResourceManager } from "../engine";
import { version } from "../../../package.json";

// Constants
const NEXT = { p: "l", l: "t" };
const PREV = { t: "l", l: "p", p: "mainmenu", options: "mainmenu" };

export default {
    data() {
        return {
            version,
            params: {},
            view: "mainmenu"
        };
    },
    computed: {
        backable() {
            return !!PREV[this.view];
        },
        difficulty: {
            get() {
                return this.$store.state.settings.difficulty;
            },
            set(value) {
                this.$store.dispatch("settings/setDifficulty", value);
            }
        },
        sound: {
            get() {
                return this.$store.state.settings.sound;
            },
            set(value) {
                this.$store.dispatch("settings/setSound", value);
            }
        }
    },
    async mounted() {
        this.music = ResourceManager.sound("song2", { loop: true });
        await ResourceManager.load();
        this.music.value.volume(0.5);
        if (this.sound) {
            this.music.value.play();
        }
    },
    beforeDestroy() {
        this.music.value.stop();
        this.music = null;
    },
    methods: {
        launch() {
            this.$emit("launch", this.params);
        },
        quickstart() {
            this.launch();
        },
        newgame() {
            this.view = "p";
        },
        showOptions() {
            this.view = "options";
        },
        back() {
            this.view = PREV[this.view];
        },
        select(key, val) {
            this.params[key] = val;
            this.view = NEXT[key] || this.launch();
        }
    },
    watch: {
        sound(value) {
            if (value) {
                this.music.value.play();
            } else {
                this.music.value.stop();
            }
        }
    }
};
</script>